"use client";

import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { flushDiagnostic } from "../../lib/diagnosticApi";
import { flushSetup } from "../../lib/diagnosticSetup";

/**
 * Saves a completed diagnostic once the visitor has an account. Renders
 * nothing.
 *
 * WHY THIS IS MOUNTED GLOBALLY RATHER THAN ON THE SIGNUP PAGE
 * Signup can complete via email OR an OAuth round trip, and the user can
 * land on /dashboard, /welcome or /billing/start depending on the path
 * they took. Hanging the flush off any one of those screens means the
 * other routes silently drop a diagnostic the student spent six minutes
 * on. Watching for "authenticated AND an unflushed run exists" catches
 * every path, including someone who takes it today and signs up tomorrow.
 *
 * Mirrors the AttributionCapture pattern for the same reason it exists.
 *
 * This handles the SIGNED-UP-AFTERWARDS case only. Someone who was already
 * signed in when they finished never changes auth state, so this effect
 * would not re-fire: the diagnostic page submits directly in that case.
 * Both call the same function, and the backend replaces rather than
 * appends, so the overlap cannot duplicate rows.
 */
export default function DiagnosticFlush() {
  const { session } = useAuth();

  useEffect(() => {
    if (!session) return;
    void flushDiagnostic();
    // The guided path's setup is saved separately and must land even when
    // the visitor declined the price: they still typed it, and it still
    // belongs on their account.
    void flushSetup();
  }, [session]);

  return null;
}
